export enum DataType {
  PHONE = 'phone',
  URL = 'url',
  SMS = 'sms',
  TEXT = 'text',
  EMAIL = 'email',
}
